angular.module('filters').filter('waiverSignedBy', function() {
  return function(waiver) {
    var contact;
    contact = waiver.signed_waiver_contacts_attributes[0];
    return `${contact.first_name} ${contact.last_name}`;
  };
});
